import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { errorConfig, successConfig, toastClass } from './utils';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  constructor(private readonly _toastrService: ToastrService) {
    _toastrService.toastrConfig = {
      ..._toastrService.toastrConfig,
      maxOpened: 5,
      preventDuplicates: true,
    };
  }

  public info = (message: string) => this._toastrService.info(message, undefined, successConfig('info'));

  public success = (message: string) => this._toastrService.success(message, undefined, successConfig('success'));

  public warning = (message: string) => this._toastrService.warning(message, undefined, errorConfig('warning'));

  public error = (message: string) => this._toastrService.error(message, undefined, errorConfig('error'));

  public isInsideNotification(target: HTMLElement) {
    return !!target.closest(`.${toastClass}`);
  }
}
